<template>
  <ui-dialog
    :isLoading="isLoading"
    :title="L10n('confirm')"
    :isVisible="true"
    @close="_closeDialog"
  >
    {{L10n('are-you-sure-close-followup')}}
    <template v-slot:footer>
      <div class="d-flex justify-content-end">
        <button class="btn btn-border grey btn-size-s btn-mobile-full" @click="_closeDialog">
          {{L10n('close')}}
        </button>
        <button class="ml-sm-3 btn btn-border blue btn-size-s btn-mobile-full" @click="_onSubmit">
          {{L10n('confirm')}}
        </button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import { createParams } from '@/utils/dynamic'
import { ServiceCustomerPOFollowUp } from '@/services/CustomerPOFollowUp'

export default {
  name: 'DialogConfirmClosePo',
  components: {
    'ui-dialog': () => import(/* webpackChunkName: 'Shared' */ '@/components/Dialogs/Dialog')
  },
  props: {
    rfqid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    _closeDialog () {
      this.$emit('onClose')
    },
    async _onSubmit () {
      try {
        if (!this.rfqid) {
          throw new Error('rfqid is required')
        }
        this.isLoading = true
        const params = createParams({
          select: 'id',
          filter: `rfqid == "${this.rfqid}"`
        })
        const { data } = await ServiceCustomerPOFollowUp.getAllDynamic(params)

        await Promise.all(data.value.map(({ id }) => {
          return ServiceCustomerPOFollowUp.patch({ id, orderPhaseID: 15 })
        }))

        this.isLoading = false
        this.$emit('onSuccess')
      } catch (e) {
        this.requestErrorHandler(e)
      }
    }
  }
}
</script>
